module.exports = __webpack_public_path__ + "static/media/servicesasesorias.3d620945.png";